import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ControlledTextField } from 'components/shared';

import { EmployerSelect } from './EmployerSelect';
import { GridCompact12 } from 'components/shared/Grid/Grid.components';

export const EmployerFields = () => {
  const { control, setValue } = useFormContext();
  const { t } = useTranslation('common', {
    keyPrefix: 'employerCostSettings.details.general'
  });

  const handleSelect = (value, label) => {
    setValue('nameBrief', label);
  };

  return (
    <>
      <GridCompact12>
        <EmployerSelect handleSelect={handleSelect} />
      </GridCompact12>
      <GridCompact12>
        <ControlledTextField
          control={control}
          variant="outlined"
          name="nameBrief"
          disabled
          label={t('employer_name_short_label')}
        />
      </GridCompact12>
    </>
  );
};
